import { ComputerDesktopIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import type { Theme } from '@xphoto/shared';
import { useI18n } from '../i18n';
import { useTheme } from '../theme';
import { Menu, type MenuOption } from './Menu';

const ICONS: Record<Theme, React.ReactNode> = {
  light: <SunIcon className="h-5 w-5" aria-hidden="true" />,
  dark: <MoonIcon className="h-5 w-5" aria-hidden="true" />,
  system: <ComputerDesktopIcon className="h-5 w-5" aria-hidden="true" />,
};

/** Menu de sélection de thème (clair/sombre/système). Icône reflète la préférence courante. */
export function ThemeMenu(): React.JSX.Element {
  const { t } = useI18n();
  const { theme, setTheme, themes } = useTheme();

  const options: MenuOption<Theme>[] = themes.map((th) => ({
    value: th,
    label: t(`theme.${th}`),
    icon: ICONS[th],
  }));

  return (
    <Menu
      label={t('menu.openTheme')}
      closeLabel={t('a11y.closeMenu')}
      trigger={ICONS[theme]}
      options={options}
      value={theme}
      onSelect={setTheme}
    />
  );
}
